import * as React from 'react';

interface IProps {
  component: any;
  description: string;
  isRequired: boolean;
  isReadOnly: boolean;
}

function addControlRow({ component, description, isRequired, isReadOnly }: IProps) {
  return (
    <tr>
      <td align="left">
        <span style={{ color: '#fff' }}>
          {description}&nbsp;
          {isRequired && !isReadOnly && <b style={{ color: 'red' }}>*</b>}
        </span>
      </td>
      <td>{component}</td>
    </tr>
  );
}

export default addControlRow;
